// Selectors


import { RootState } from '../../store';

export const demoCredentialSelector = (state: RootState) => state.demoCredentialState
